// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__a18LB","header":"PatientQuestionnaire_header__1UFqt","info":"PatientQuestionnaire_info__6YkRV"};